import { render } from "./description-footer.vue?vue&type=template&id=e845a6ae"
import script from "./description-footer.vue?vue&type=script&lang=js"
export * from "./description-footer.vue?vue&type=script&lang=js"

import "./description-footer.vue?vue&type=style&index=0&id=e845a6ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__